import apiClient from "./config";

// Renamed (was generateReviewer) to avoid barrel conflict
export const generateAI = async (payload) => {
  try {
    const response = await apiClient.post("/generate", payload);
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.error || error.message || "AI Generation Failed"
    );
  }
};

export const regenerateSingleQuestion = async (payload) => {
  try {
    const response = await apiClient.post("/regenerate-question", payload);
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.error ||
        error.response?.data?.message ||
        error.message ||
        "Question regeneration failed"
    );
  }
};
